module.exports = __webpack_public_path__ + "static/media/HCMM138.ac53c4bf.jpg";